import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { fetchRosterUser } from '@/services/roster/roster-service';

interface UseRosterUserParams {
  userId?: string;
}

export function rosterUserQuery(userId: string) {
  return {
    queryKey: ['user', userId],
    queryFn: () => fetchRosterUser(userId),
    enabled: Boolean(userId),
    staleTime: Infinity,
  } satisfies UseQueryOptions;
}

export function useRosterUser({ userId }: UseRosterUserParams) {
  return useQuery(rosterUserQuery(userId!));
}
